import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the integration APIs 
 */
export class IntegrationService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getDefinitions() {
		var data = await this.makeGETRequest('/api/resource/integration-definitions');		
		return data;
	}

	async getIntegrationGuide(transmissionType) {
		var encoded = encodeURIComponent(transmissionType);
		var data = await this.makeGETRequest('/api/resource/integration-definitions/' + encoded + '/guide');
		return data;
	}
	
	async getDataHandlers(module, dataType) {
		var params = '';
		if (module || dataType) {
			var moduleType = {				
			};
			if (module) {
				moduleType.module = module;
			}
			if (dataType) {
				moduleType.dataType = dataType;
			}
			params = '?' + this.toQueryParam(moduleType);
		}
		var data = await this.makeGETRequest('/api/resource/integration-definitions/data-handlers' + params);		
		return data;
	}	
	
	async getDataPropertyDefinitions(module, dataType, handlerId) {
		var params = '';
		if (handlerId) {
			params = '?' + this.toQueryParam({ handlerId: handlerId });
		}
		var data = await this.makeGETRequest('/api/resource/integration-definitions/data-properties/' + module + '/' + dataType + params);		
		return data;
	}	
	
	async getAutoUnits(companyId) {
		var params = '';
		if (companyId) {
			params = 'companyId=' + companyId;
		}
		var data = await this.makeGETRequest('/api/resource/integration-definitions/auto-units?' + params);		
		return data;
	}

	async getAutoGroups(companyId, dataType) {
		var params = [];
		if (companyId) {
			params.push('companyId=' + companyId);
		}
		if (dataType) {
			params.push('dataType=' + dataType);
		}
		var query = params.length > 0 ? ('?' + params.join('&')) : '';
		var data = await this.makeGETRequest('/api/resource/integration-definitions/auto-groups' + query);
		return data;
	}

	async getDataTransformRuleSets(companyId, dataType) {
		var params = [];
		if (companyId) {
			params.push('companyId=' + companyId);
		}
		if (dataType) {
			params.push('dataType=' + dataType);
		}
		var query = params.length > 0 ? ('?' + params.join('&')) : '';
		var data = await this.makeGETRequest('/api/resource/integration-definitions/data-transform-rule-sets' + query);
		return data;
	}
	
	async getDataFilters(companyId) {
		var params = '';
		if (companyId) {
			params = 'companyId=' + companyId;
		}
		var data = await this.makeGETRequest('/api/resource/integration-definitions/data-filters?' + params);		
		return data;
	}
	
	async getGPSFilters(companyId) {
		var params = '';
		if (companyId) {
			params = 'companyId=' + companyId;
		}
		var data = await this.makeGETRequest('/api/resource/integration-definitions/gps-filtering-rules?' + params);		
		return data;
	}
	
	async getUnitMatchingRules(companyId) {
		var params = '';
		if (companyId) {
			params = 'companyId=' + companyId;
		}
		var data = await this.makeGETRequest('/api/resource/integration-definitions/unit-matching-rules?' + params);		
		return data;
	}
	
	//locks	
	async getIntegrationLocks(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/integration-locks' + params);		
		return data;
	}	
	
	async getIntegrationLock(lockId) {
		var data = await this.makeGETRequest('/api/resource/integration-locks/' + lockId);		
		return data;
	}
	
	async saveIntegrationLock(lock, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/integration-locks/' + lock.lockId, lock);
		} else {
			saved = await this.makePOSTRequest('/api/resource/integration-locks', lock);
		}
		return saved;
	}	
	
	async deleteIntegrationLock(lockId) {		
		var result = await this.makeDELETERequest('/api/resource/integration-locks/' + lockId);		
		return result;
	}	
	
	//transmission properties
	async getTransmissionProperties(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/transmission-properties');		
		return data;
	}	
	
	async getTransmissionProperty(propertyId) {
		var data = await this.makeGETRequest('/api/resource/transmission-properties/' + propertyId);		
		return data;
	}	
	
	async saveTransmissionProperty(property, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/transmission-properties/' + property.propertyId, property);
		} else {
			saved = await this.makePOSTRequest('/api/resource/transmission-properties', property);
		}
		return saved;
	}	
	
	async deleteTransmissionProperty(propertyId) {		
		var result = await this.makeDELETERequest('/api/resource/transmission-properties/' + propertyId);		
		return result;
	}	
	
	//integrations
	async getIntegrations(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/integrations' + params);		
		return data;
	}

	exportIntegrations(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/integrations/export' + params);
	}
	
	async getAvailableModules() {	
		var data = await this.makeGETRequest('/api/resource/integrations/available-modules');		
		return data;
	}

	async getModuleDataHandlers(module) {
		var data = await this.makeGETRequest('/api/resource/integrations/module-data-handlers/' + encodeURIComponent(module));
		return data;
	}
	
	async getAvailableStatus() {	
		var data = await this.makeGETRequest('/api/resource/integrations/available-status');		
		return data;
	}		
	
	async getIntegration(configId) {
		var data = await this.makeGETRequest('/api/resource/integrations/' + configId);		
		return data;
	}
	
	async getIntegrationDetail(configId) {
		var data = await this.makeGETRequest('/api/resource/integrations/' + configId + '/detail');		
		return data;
	}	
	
	async getIntegrationRuns(configId) {
		var data = await this.makeGETRequest('/api/resource/integrations/' + configId + '/runs');		
		return data;
	}	
	
	async submitRun(configId, integrationRun) {
		var data = await this.makePOSTRequest('/api/resource/integrations/' + configId + '/runs', integrationRun, {
			displayValidationErrors: false
		});		
		return data;
	}
	
	async saveIntegration(configAll, edit, template) {
		var templateParam = '';
		if (template) {
			templateParam = '?template=' + template;
		}
		
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/integrations/' + configAll.config.configId + templateParam, configAll);
		} else {
			saved = await this.makePOSTRequest('/api/resource/integrations' + templateParam, configAll);
		}
		return saved;
	}	
	
	async submitFeedback(configId, feedback) {	
		var result = await this.makePOSTRequest('/api/resource/integrations/' + configId + '/feedback', feedback);
		return result;
	}
	
	async backPull(configId, backPull) {	
		var result = await this.makePUTRequest('/api/resource/integrations/' + configId + '/backpull', backPull);
		return result;
	}

	async updatePullDates(configId, configFileId, pullDates) {
		var result = await this.makePUTRequest(
			'/api/resource/integrations/' + configId + '/config-files/' + configFileId + '/pull-dates',
			pullDates
		);
		return result;
	}	
	
	async resetRunStatus(multipleIds) {	
		var result = await this.makePUTRequest('/api/resource/integrations/reset-run-status', multipleIds);
		return result;
	}	
	
	async changeStatus(multipleIds, status) {	
		var result = await this.makePUTRequest('/api/resource/integrations/change-status/' + status, multipleIds);
		return result;
	}	
	
	async deleteIntegration(configId) {		
		var result = await this.makeDELETERequest('/api/resource/integrations/' + configId);		
		return result;
	}

	getConnectivityCheckStorageKey(configId) {
		return 'connectivityCheck:' + configId;
	}

	async getConnectivityCheckOptions(configId) {
		return await this.makeGETRequest('/api/resource/integrations/' + configId + '/connectivity-check/options');
	}

	/**
	 * Returns active RUNNING session view, or null if none.
	 */
	async getActiveConnectivityCheck(configId) {
		var data = await this.makeGETRequest('/api/resource/integrations/' + configId + '/connectivity-check/active');
		if (!data || !data.active || !data.session) {
			return null;
		}
		return data.session;
	}

	/**
	 * Starts async connectivity check session. On 409 returns active session body.
	 */
	async startConnectivityCheck(configId, executionMode) {
		var body = {};
		if (executionMode) {
			body.executionMode = executionMode;
		}
		var res = await this.performFetch('/api/resource/integrations/' + configId + '/connectivity-check', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body)
		});
		if (res.ok) {
			var data = await res.json();
			this.displayValidationErrors(data);
			return data;
		}
		if (res.status === 409) {
			return await res.json();
		}
		this.handleResponseError(res, {
			url: '/api/resource/integrations/' + configId + '/connectivity-check',
			method: 'POST',
			data: body
		});
		var error = new Error('Communication Failure');
		error.res = res;
		return Promise.reject(error);
	}

	async getConnectivityCheckStatus(configId, sessionId) {
		return await this.makeGETRequest('/api/resource/integrations/' + configId + '/connectivity-check/' + sessionId);
	}

	async cancelConnectivityCheck(configId, sessionId) {
		return await this.makePUTRequest('/api/resource/integrations/' + configId + '/connectivity-check/' + sessionId + '/cancel', {});
	}
	
	//----> Integration Logs
	async getIntegrationsLogs(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/integration-logs' + params);		
		return data;
	}

	exportIntegrationsLogs(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/integration-logs/export' + params);
	}
		
}
